// Данните за значката „⇄" в редовете на „Наличности": замените в склада за
// периода (по подразбиране последните 30 дни) се теглят ВЕДНЪЖ за цялата
// справка и се групират по продукт — редът само чете `byProduct.get(id)`.
// Употреба: `const { byProduct, period } = useStockSubstitutionSummary(warehouseId)`
// → `<StockSubstitutionBadge summary={byProduct.get(row.productId)} period={period} … />`.
import { useMemo } from "react";
import { useWarehouseSubstitutions } from "../../../../hooks/useInventoryStockCard";
import { periodToParams, type Period } from "../../components/period/periodPresets";
import { defaultCardPeriod } from "./stockCardModel";
import { groupSubstitutionsByProduct } from "./stockSubstitutionModel";

export const useStockSubstitutionSummary = (warehouseId: number | null, period?: Period) => {
  // Пресетът се смята от ДНЕС — ключът на заявката е стабилен в рамките на деня
  const effectivePeriod = useMemo(() => period ?? defaultCardPeriod(), [period]);
  const params = useMemo(
    () => (warehouseId != null ? { warehouseId, ...periodToParams(effectivePeriod) } : null),
    [warehouseId, effectivePeriod],
  );
  const { data, isLoading } = useWarehouseSubstitutions(params);
  const byProduct = useMemo(() => groupSubstitutionsByProduct(data ?? []), [data]);
  return { byProduct, period: effectivePeriod, isLoading };
};
